import { useState, useEffect} from 'react'

export function useIsMobile(){
    //const [ userMobile, setUserMobile ] = useState()
    const [ isMobile, setIsMobile ] = useState()
    const [ isOS, setIsOS ] = useState()
    
    //Valida si es desktop o mobile
    useEffect(()=>{
        if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            //setUserMobile('desktop')
            setIsMobile('desktop')
        }
        else{
            //setUserMobile('movil')
            setIsMobile('movil')
            if(/Android/i.test(navigator.userAgent)){ setIsOS('Android') }
            else if(/iPhone|iPad|iPod/i.test(navigator.userAgent)){ setIsOS('iOS') }
            else{ setIsOS('Other') }
        }
    },[])

    return{
        isMobile,
        isOS
    }
}